
/**
 * @param {Number} ARGB
 * @returns {String} #RGBA
 */
export function ARGBToRGBA (ARGB) {
  const color = ARGB.toString(16).toUpperCase().split('')
  const newColor = color.slice(2, color.length).concat(color.slice(0, 2)).join('')
  return `#${newColor}`
}

// 函数节流
export function throttle (fn, interval = 1500) {
  let enterTime = 0 // 触发的时间
  const gapTime = interval // 间隔时间，如果interval不传，则默认2000ms
  return function (e) {
    const that = this
    const backTime = new Date() // 第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(that, e, arguments)
      enterTime = backTime // 赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  }
}
// 函数防抖
export function debounce (fn, interval = 2000) {
  let timer
  const gapTime = interval // 间隔时间，如果interval不传，则默认2000ms
  return function (e) {
    clearTimeout(timer)
    const that = this
    const args = arguments // 保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function () {
      fn.call(that, e, args)
    }, gapTime)
  }
}

export function isPhone (str) {
  /* eslint-disable */
  const reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
  return reg.test(str)
}

export function formatMoney (num) {
  return (num/100).toFixed(2)
}

export function scrollTop (num) {
  document.documentElement.scrollTop = document.body.scrollTop = num;
}
